import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import './style.less';
import { actions } from 'ducks/ui';

const Template = ({ setBackground, resetBackground }) => {
  useEffect(() => {
    setBackground();
    return resetBackground;
  }, [resetBackground, setBackground]);
  return (
    <div className="NotFound">
      <div className="wrapper">
        <h1>
          <FormattedMessage id="NotFound.message" />
        </h1>
      </div>
    </div>
  );
};

Template.propTypes = {
  setBackground: PropTypes.func.isRequired,
  resetBackground: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setBackground: () => dispatch(actions.background.white()),
  resetBackground: () => dispatch(actions.background.reset()),
});

const NotFound = connect(mapStateToProps, mapDispatchToProps)(Template);

export default NotFound;
